var map = {
	"./Feather_001.jpg": 2141,
	"./Feather_002.jpg": 4867,
	"./Feather_003.jpg": 8081,
	"./Feather_03.jpg": 5419,
	"./Feather_05.jpg": 823,
	"./Feather_08.jpg": 7073,
	"./Feather_15.jpg": 1475,
	"./Feather_16.jpg": 5854,
	"./Feather_17.jpg": 38,
	"./Feather_18.jpg": 6422,
	"./Feather_19.jpg": 3961,
	"./Feather_20.jpg": 8971,
	"./Feather_21.jpg": 3277,
	"./Feather_22.jpg": 3204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2518;